import React from 'react'

import './ServicesComponent.css'

//MUI
import { Box, Button, Container, Grid, Typography, useMediaQuery } from '@mui/material'
import { styled } from '@mui/material/styles';

//images
import img_9 from '../../assets/images/img_9_full.png'
import img_10 from '../../assets/images/img_10_full.png'
import img_11 from '../../assets/images/img_11_full.png'
import img_12 from '../../assets/images/img_12_full.png'
import img_13 from '../../assets/images/img_13_full.png'
import img_14 from '../../assets/images/img_14_full.png'
import img_15 from '../../assets/images/img_15_full.png'

//Components
import SecondForm from '../Form/Form';

//Router dom
import { Link } from 'react-router-dom';

const CustomButton = styled(Button)(({ theme }) => ({
    color: '#fff',
    backgroundColor: '#011E41',
    textTransform: 'none',
    fontWeight: '600',
    width: '150px',
    height: '50px',
    '&:hover': {
        backgroundColor: '#2F5A90',
    },
}));

const ServicesComponent = () => {

    const matchesMobile = useMediaQuery('(max-width: 500px)')

    return (
        <>
            <Box sx={{ mt: { xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 0 }, width: '100%' }}>
                <Box sx={{ width: { xxl: '70%', xl: '70%', lg: '85%', md: '95%', sm: '100%', xs: '100%' }, mr: 'auto' }}>
                    <Grid container spacing={4} alignItems="center" className='services_grid_top_container'>
                        <Grid
                            size={{ xxl: 5, xl: 5, lg: 5, md: 5, sm: 5.5, xs: 12 }}
                            order={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                            sx={{ display: 'flex' }}
                        >
                            <Box
                                component="img"
                                src={img_9}
                                alt={img_9}
                                sx={{
                                    width: '100%',
                                    height: { xxl: 550, xl: 450, lg: 500, md: 450, sm: 450, xs: 400 },
                                    objectFit: 'cover',
                                }}
                            />
                        </Grid>
                        <Grid
                            className='services_grid_top'
                            size={{ xxl: 7, xl: 7, lg: 7, md: 7, sm: 6.5, xs: 12 }}
                            order={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 2 }}
                        >
                            <Typography variant='h4' sx={{ fontWeight: '900', mb: 3, color: '#fff' }}>
                                Unidad móvil
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#fff', mb: 3 }}>
                                En Factor + Health entendemos que el tiempo de su equipo y el cumplimiento normativo son prioritarios. Por ello, llevamos
                                nuestros servicios de Unidad Médica Móvil directamente a su empresa para poder realizar los estudios que su organización necesita
                                para la vigilancia al personal ocupacionalmente expuesto, evitando asi riesgos a la salud o enfermedades de origen laboral
                            </Typography>
                            <Box sx={{ textAlign: { xxl: 'left', xl: 'left', lg: 'left', md: 'left', sm: 'left', xs: 'center' } }}>
                                <CustomButton variant='contained' component={Link} to='/contacto'>
                                    Contáctanos
                                </CustomButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            <Box sx={{ mt: { xxl: 8, xl: 8, lg: 8, md: 6, sm: 0, xs: 8 }, width: '100%', mb: 8 }}>
                <Box sx={{ width: { xxl: '70%', xl: '70%', lg: '85%', md: '95%', sm: '100%', xs: '100%' }, ml: 'auto' }}>
                    <Grid container spacing={4} alignItems="center" className='services_grid2_top_container'>
                        <Grid
                            className='services_grid2_top'
                            size={{ xxl: 7, xl: 7, lg: 7, md: 7, sm: 6.5, xs: 12 }}
                        >
                            <Typography variant='h4' sx={{ fontWeight: '900', mb: 3, color: '#004A86' }}>
                                SERVICIO MÉDICO INPLANT
                            </Typography>
                            <ul style={{ color: '#868686' }}>
                                <li style={{ marginBottom: '8px' }}>Profesionales de la salud.</li>
                                <li style={{ marginBottom: '8px' }}>Diagnóstico de salud, matriz de riesgo nom stps, control de expediente medico.</li>
                                <li style={{ marginBottom: '8px' }}>Recorridos para identificar riesgos a la salud.</li>
                                <li style={{ marginBottom: '8px' }}>Control de expediente médico.</li>
                                <li>Seguimiento st7, st9, ipp, st1, st2 y reportes ejecutivos mensuales.</li>
                            </ul>
                        </Grid>
                        <Grid
                            size={{ xxl: 5, xl: 5, lg: 5, md: 5, sm: 5.5, xs: 12 }}
                            sx={{ display: 'flex' }}
                        >
                            <Box
                                className='services_img2_top'
                                component="img"
                                src={img_10}
                                alt={img_10}
                                sx={{
                                    width: '100%',
                                    height: { xxl: 550, xl: 450, lg: 500, md: 450, sm: 450, xs: 400 },
                                    objectFit: 'cover',
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            <Container maxWidth='xl' sx={{ mt: 10 }}>
                <Box sx={{ textAlign: 'center' }}>
                    <img src={img_11} alt={img_11} className='al_img' />
                </Box>
            </Container>

            <Box sx={{ mt: 10, width: '100%', mb: 8 }}>
                <Box sx={{ width: { xxl: '65%', xl: '65%', lg: '85%', md: '95%', sm: '100%', xs: '100%' }, mx: 'auto' }}>
                    <Grid container spacing={matchesMobile ? 1 : 4} alignItems="center" className='services_grid12_top_container'>
                        <Grid
                            size={{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}
                            sx={{ display: 'flex' }}
                        >
                            <Box
                                className='services_img12_top'
                                component="img"
                                src={img_12}
                                alt={img_12}
                                sx={{
                                    width: '100%',
                                    height: { xxl: 550, xl: 450, lg: 500, md: 450, sm: 450, xs: 400 },
                                    objectFit: 'cover',
                                }}
                            />
                        </Grid>
                        <Grid
                            className='services_grid2_top'
                            size={{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}
                        >
                            <Typography variant='h4' className='services_title12' sx={{ fontWeight: '900', mb: 3, color: '#004A86' }}>
                                CAMPAÑAS DE SALUD
                            </Typography>
                            <ul style={{ color: '#868686' }}>
                                <li style={{ marginBottom: '12px' }}>Radiología.</li>
                                <li style={{ marginBottom: '12px' }}>Audiometría.</li>
                                <li style={{ marginBottom: '12px' }}>Espirometría.</li>
                                <li style={{ marginBottom: '12px' }}>Análisis clínicos.</li>
                            </ul>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            <Container maxWidth='lg' sx={{ mt: 10, mb: 5 }}>
                <Typography variant={matchesMobile ? 'h5' : 'h4'} sx={{ fontWeight: '900', mb: 3, color: '#004A86' }} textAlign='center'>
                    Además de Estudios en nuestra Unidad médica móvil, ofrecemos:
                </Typography>
            </Container>

            <Box>
                <Box sx={{ width: { xxl: '65%', xl: '65%', lg: '85%', md: '95%', sm: '100%', xs: '100%' }, mx: 'auto' }}>
                    <Grid container spacing={0} alignItems="center" className='services_grid13_14'>
                        <Grid
                            size={{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}
                            sx={{ display: 'flex' }}
                        >
                            <Box
                                className='services_img13'
                                component="img"
                                src={img_13}
                                alt={img_13}
                                sx={{
                                    width: '100%',
                                    height: { xxl: 550, xl: 450, lg: 500, md: 450, sm: 450, xs: 400 },
                                    objectFit: 'cover',
                                }}
                            />
                        </Grid>
                        <Grid
                            className='services_grid13'
                            size={{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}
                        >
                            <ul style={{ color: '#868686' }}>
                                <li style={{ marginBottom: '8px' }}>Programas de Salud Ocupacional (Médicos inplant, campañas).</li>
                                <li style={{ marginBottom: '8px' }}>Capacitaciones en Normatividad (IMSS, SSA, COFEPRIS, STPS, LFT).</li>
                                <li>Soluciones Personalizadas para cualquier industria nacional o extranjera.</li>
                            </ul>
                        </Grid>
                        <Grid
                            className='services_grid14'
                            size={{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}
                        >
                            <Typography variant='body1' sx={{ fontWeight: 'bold', fontSize: '22px', color: '#004A86' }}>Servicio Integral en un solo lugar:</Typography>
                            <ul style={{ color: '#868686' }}>
                                <li style={{ marginBottom: '8px' }}>Evite traslados y pérdida de productividad. (Todo en la ubicación de su empresa)</li>
                                <li style={{ marginBottom: '8px' }}>En los horarios que usted lo requiera.</li>
                                <li>En el tiempo que su empresa lo necesita.</li>
                            </ul>
                        </Grid>
                        <Grid
                            size={{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}
                            sx={{ display: 'flex' }}
                        >
                            <Box
                                className='services_img14'
                                component="img"
                                src={img_14}
                                alt={img_14}
                                sx={{
                                    width: '100%',
                                    height: { xxl: 550, xl: 450, lg: 500, md: 450, sm: 450, xs: 400 },
                                    objectFit: 'cover',
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            <Container maxWidth='xl' sx={{ mt: 10 }}>
                <Typography variant='h4' sx={{ fontWeight: '900', mb: 3, color: '#004A86' }} textAlign='center'>
                    EXÁMENES MÉDICOS
                </Typography>
                <Typography variant='body1' textAlign='center'>
                    El conocer la condición de salud de forma integral de tus colaboradores te ayuda a tener una población sana y
                    cumplimiento de la <span style={{ fontWeight: '900' }}>NOM 30 STPS.</span>
                </Typography>
                <Grid container spacing={2} alignItems='center' sx={{ mt: 5 }}>
                    <Grid size={{ xxl: 7, xl: 7, lg: 7, md: 6, sm: 12, xs: 12 }}>
                        <img src={img_15} alt={img_15} width='100%' style={{ borderRadius: '5px' }} />
                    </Grid>
                    <Grid size={{ xxl: 5, xl: 5, lg: 5, md: 6, sm: 12, xs: 12 }}>
                        <ul style={{ color: '#868686' }}>
                            <li style={{ marginBottom: '8px' }}>De ingreso</li>
                            <li style={{ marginBottom: '8px' }}>Periódicos</li>
                            <li style={{ marginBottom: '8px' }}>Por cambio de puesto</li>
                            <li>De egreso</li>
                        </ul>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth='xl' sx={{ mt: 10, mb: 5 }}>
                <Typography sx={{ fontWeight: '900', color: '#004A86', fontSize: matchesMobile ? '34px' : '38px', mb: 3 }} textAlign='center'>
                    Dudas y cotizaciones
                </Typography>
                <SecondForm type={'quote'} />
            </Container>
        </>
    )
}

export default ServicesComponent